import { render, staticRenderFns } from "./CourtArbitration.vue?vue&type=template&id=2dd5f7f9&scoped=true&"
import script from "./CourtArbitration.vue?vue&type=script&lang=js&"
export * from "./CourtArbitration.vue?vue&type=script&lang=js&"
import style0 from "./CourtArbitration.vue?vue&type=style&index=0&id=2dd5f7f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5f7f9",
  null
  
)

export default component.exports